import { render, staticRenderFns } from "./MainLog.vue?vue&type=template&id=0a6ea940&"
import script from "./MainLog.vue?vue&type=script&lang=ts&"
export * from "./MainLog.vue?vue&type=script&lang=ts&"
import style0 from "./MainLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports